module.exports = __webpack_public_path__ + "img/horizontal_3_4_8019.fcac738a.png";